import { CreateOrderRequest } from '@models/order';

/**
 * v1 주문 요청에 추가된 필드의 기본값.
 * 주문 요청을 새로 만드는 곳(상품상세·장바구니·재주문 등)에서 펼쳐 사용한다.
 */
export const defaultOrderFields: Pick<CreateOrderRequest,
    'pgAmount' | 'giftAmount' | 'prepaidCardAmount' | 'giftPayments' | 'prepaidCardPayments'
    | 'saveNote' | 'savePaymentMethod' | 'useEmployeeDiscount' | 'saveCashReceipt'> = {
        pgAmount: 0,
        giftAmount: 0,
        prepaidCardAmount: 0,
        giftPayments: [],
        prepaidCardPayments: [],
        saveNote: false,
        savePaymentMethod: false,
        useEmployeeDiscount: false,
        saveCashReceipt: false,
    };
